// Reconstructed from production code; original paths and local names were not available.
const trackingParams = /^(utm_|fbclid$|gclid$|dclid$|msclkid$|mc_[a-z0-9_]+$)/i;
function normalizePath(l) {
  const i = String(l || "/").trim();
  return !i || i === "/" ? "/" : `/${i.replace(/^\/+|\/+$/g, "")}`;
}
function joinPaths(...l) {
  const i = l.map((c) => normalizePath(c)).filter((c) => c !== "/");
  return i.length ? `/${i.map((c) => c.slice(1)).join("/")}` : "/";
}
function cleanQuery(l = "") {
  const i = String(l || "")
    .trim()
    .replace(/^\?/, "");
  if (!i) return "";
  const c = new URLSearchParams(i);
  for (const d of [...c.keys()]) trackingParams.test(d) && c.delete(d);
  const s = c.toString();
  return s ? `?${s}` : "";
}
function hasUnknownQueryParams(l = "", i = []) {
  const c = new Set(i);
  return [
    ...new URLSearchParams(String(l || "").replace(/^\?/, "")).keys(),
  ].some((d) => !trackingParams.test(d) && !c.has(d));
}
function siteOrigin(l) {
  const i = l || "https://we-in.nolimits.tn/";
  try {
    const c = new URL(i);
    return c.protocol !== "http:" && c.protocol !== "https:"
      ? ""
      : ((c.search = ""),
        (c.hash = ""),
        (c.pathname = c.pathname.replace(/\/+$/, "") || "/"),
        c.toString().replace(/\/$/, ""));
  } catch {
    return "";
  }
}
function canonicalUrl(l, i = "/", c = "") {
  const s = siteOrigin(l);
  if (!s) return "";
  try {
    const d = new URL(s),
      f = normalizePath("/"),
      m = normalizePath(d.pathname),
      y = f === "/" || m === f || m.endsWith(f) ? m : joinPaths(m, f);
    d.pathname = joinPaths(y, i);
    d.search = cleanQuery(c);
    d.hash = "";
    return d.toString();
  } catch {
    return "";
  }
}
function normalizeText(l, i) {
  const c = String(l || "")
    .replace(/\s+/g, " ")
    .trim();
  return !i || c.length <= i ? c : c.slice(0, i - 1).trimEnd() + "…";
}
function seoLocale(l, i) {
  return i || (String(l || "en").toLowerCase() === "ar" ? "ar_TN" : "en_US");
}
function absoluteImageUrl(l, i) {
  if (!l || /^data:/i.test(String(l))) return null;
  try {
    const c = new URL(l, i || void 0);
    return c.protocol !== "http:" && c.protocol !== "https:"
      ? null
      : ((c.hash = ""), c.toString());
  } catch {
    return null;
  }
}
function canonicalImageUrl(l, i) {
  const c = absoluteImageUrl(l, i);
  if (!c) return null;
  const s = new URL(c);
  s.search = cleanQuery(s.search);
  s.hash = "";
  return s.toString();
}
function safeJsonLd(l) {
  return JSON.stringify(l)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
function pageTitle(l, i) {
  const c = normalizeText(l),
    s = normalizeText(i);
  return c
    ? !s ||
      c.toLocaleLowerCase().includes(s.toLocaleLowerCase()) ||
      c.toLocaleLowerCase().endsWith(`| ${s}`.toLocaleLowerCase())
      ? c
      : `${c} | ${s}`
    : s;
}
export {
  trackingParams,
  normalizePath,
  joinPaths,
  cleanQuery,
  hasUnknownQueryParams,
  siteOrigin,
  canonicalUrl,
  normalizeText,
  seoLocale,
  absoluteImageUrl,
  canonicalImageUrl,
  safeJsonLd,
  pageTitle,
};
